<mat-dialog-content class="loren-asset-details-charts-dialog">
  <p class="loren-asset-details-charts-dialog-text">
    {{ "asset_details.excel_selected" | transloco }}
  </p>

  <mat-radio-group
    required
    aria-label="Select aggregation"
    class="loren-asset-details-charts-dialog-radio"
    name="aggregation"
    [value]="aggregation()"
    (change)="aggregation.set($event.value)">
    <mat-label>{{ "asset_details.data_is" | transloco }}:</mat-label>
    <div class="loren-asset-details-charts-dialog-radio-button">
      <mat-radio-button [value]="aggregationOptions.MINUTES">
        {{ "asset_details.raw" | transloco }}
      </mat-radio-button>
    </div>
    <div class="loren-asset-details-charts-dialog-radio-button">
      <mat-radio-button [value]="aggregationOptions.HOURS">
        {{ "asset_details.aggregated" | transloco }}
      </mat-radio-button>
    </div>
  </mat-radio-group>

  <mat-dialog-actions class="loren-asset-details-charts-dialog-actions">
    <button matButton="filled" class="btn-secondary" (click)="onCancel()">
      {{ "asset_details.cancel" | transloco }}
    </button>
    <button matButton="filled" [mat-dialog-close]="aggregation()">
      {{ "asset_details.save" | transloco }}
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
